import styled from "styled-components";
import { tokens } from "../../../public/tokens";

const { colors, globals, typography } = tokens;

export const UploadBox = styled.div(({ $dragActive, $hasError }) => ({
  display: "flex",
  height: "152px",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  gap: globals["spacing-0-5"],
  width: "100%",
  backgroundColor: colors.neutral.grey["100"],
  border: `1px solid ${
    $hasError
      ? colors.ui.destructive
      : $dragActive
        ? colors.ui.ring
        : colors.surfaces["border-divider"]
  }`,
  boxShadow: $hasError ? "0 0 0 0.2rem rgb(220 53 69 / 25%)" : undefined,
  borderRadius: globals["border-radius"],
  textAlign: "center",
  transition: "border-color 0.2s ease-in-out",
  overflow: "hidden",
}));

export const UploadPlaceholderIcon = styled.i({
  color: colors.neutral.grey["400"],
  fontSize: typography.fontSize["3xl-24px"],
  lineHeight: "24px",
});

export const UploadPlaceholderText = styled.span({
  color: colors.neutral.grey["400"],
  fontFamily: globals["font-family"],
  fontSize: typography.fontSize["lg-14px"],
  lineHeight: "24px",
});

export const UploadPreviewImage = styled.img({
  display: "block",
  width: "100%",
  height: "100%",
  maxWidth: "100%",
  maxHeight: "100%",
  objectFit: "contain",
  borderRadius: globals["border-radius"],
});

export const UploadActions = styled.div({
  display: "flex",
  alignItems: "center",
  gap: globals["spacing-2"],
  marginTop: "1rem",
  borderRadius: globals["border-radius"],
});

export const EditorWrapper = styled.div(({ hasError }) => ({
  "& .cke, & .cke_chrome": {
    borderColor: hasError ? colors.states.alert["400"] : undefined,
    boxShadow: hasError ? "0 0 0 0.2rem rgb(220 53 69 / 25%)" : undefined,
    transition: "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
  },
}));

